"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/contexts/update-current-context/update-current-context.ts
var update_current_context_exports = {};
__export(update_current_context_exports, {
  updateCurrentContext: () => updateCurrentContext
});
module.exports = __toCommonJS(update_current_context_exports);

// src/utils/constants.ts
var defaultOldEventTimeLimit = 14 * 24 * 60 * 60 * 1e3;
var defaultMutexLockTimeout = 5e3;

// src/utils/mutex/generate-lock-id.ts
function generateLockId({ lockTime, expiration } = {}) {
  let time = typeof lockTime === "number" ? lockTime : Date.now();
  let expires = typeof expiration === "number" ? expiration : 5e3;
  const lockId = `${self.crypto.randomUUID()}+${time + expires}`;
  return lockId;
}

// src/batching/cleanup-events/cleanup-events.ts
function acquireCleanupLock(params) {
  const lock = generateLockId(params);
  if (window.yvaDatastore && (!window.yvaDatastore.cleanupLock || parseInt(window.yvaDatastore.cleanupLock.split("+")[1], 10) < Date.now())) {
    window.yvaDatastore.cleanupLock = lock;
  }
  return lock;
}
async function cleanupEvents() {
  if (window.yvaDatastore && !window.yvaDatastore.config.debug) {
    const now = Date.now();
    const lock = acquireCleanupLock({ lockTime: now });
    const limit = window.yvaDatastore.config.oldEventTimeLimit ?? defaultOldEventTimeLimit;
    if (window.yvaDatastore.cleanupLock === lock) {
      const eventsToClean = window.yvaDatastore.events.filter(
        (event) => event.status === "sent" || event.data.created < now - limit
      );
      eventsToClean.forEach((event) => {
        if (window.yvaDatastore) {
          const index = window.yvaDatastore.events.findIndex(
            (eventInDatastore) => eventInDatastore.data.eventId === event.data.eventId
          );
          if (typeof index !== "undefined" && index >= 0) {
            window.yvaDatastore.events.splice(index, 1);
          }
        }
      });
      window.yvaDatastore.cleanupLock = null;
    }
  }
}

// src/batching/lock-events/lock-events.ts
async function lockEvents() {
  if (typeof window !== "undefined" && window.yvaDatastore) {
    const now = Date.now();
    const expiration = window.yvaDatastore.config.mutexLockTimeout ?? defaultMutexLockTimeout;
    const limit = window.yvaDatastore.config.oldEventTimeLimit ?? defaultOldEventTimeLimit;
    const lockVersion = generateLockId({ expiration, lockTime: now });
    const events = [];
    window.yvaDatastore.events.forEach((event) => {
      if (event.status === "ready" && (event.lockId === null || parseInt(event.lockId.split("+")[1], 10) < now) && event.data.created > now - limit) {
        event.lockId = lockVersion;
        events.push(event);
      }
    });
    if (events.length > 0) {
      return {
        events,
        lockVersion
      };
    }
  }
  return { events: null, lockVersion: null };
}

// src/utils/time/timestamp.ts
function timestamp() {
  const origin = performance.timeOrigin;
  const elapsed = performance.now();
  const date = new Date(origin + elapsed);
  const microseconds = parseInt(
    /**
     * Performance.now return value.
     * ```
     * 123    . 123     4567
     * millis . micros  floating point others
     * ```
     *
     * Multiplying by `1000` converts the timestamps from milliseconds to microseconds.
     *
     * Adding origin time to elapsed, because elapsed might not have the full 6-digit fidelity for microseconds as required by the API.
     */
    Math.floor(origin * 1e3 + elapsed * 1e3).toString().slice(-6),
    10
  );
  return {
    /** The ISO-8601 date time string. */
    iso: date.toISOString(),
    /** The microseconds in which the time stamp was created. */
    microseconds,
    /** Unix milliseconds since 1970 or whatever caused Y2K. */
    unix: date.getTime()
  };
}

// src/batching/send-event-batch/send-event-batch.ts
async function sendEventBatch(data, options = { debug: false, requestMode: "fetch" }) {
  return new Promise((resolve, reject) => {
    const { unix, microseconds } = timestamp();
    let payloadJsonString = JSON.stringify({
      context: data.payload.context,
      // Tech debt: golang unix timestamps are in seconds, not milliseconds. So we have to convert before sending to the API.
      events: data.payload.events.map((event) => ({ ...event, created: Math.floor(event.created / 1e3) })),
      sent: Math.floor(unix / 1e3),
      sentMicros: microseconds
    });
    switch (options.requestMode) {
      case "beacon":
        if (options.debug) {
          console.log("firing beacon with", payloadJsonString);
        }
        const beacon = navigator.sendBeacon(data.url, new Blob([payloadJsonString], { type: "application/json" }));
        resolve(beacon);
        break;
      case "fetch":
      default:
        fetch(data.url, {
          body: payloadJsonString,
          headers: {
            "Content-Type": "application/json"
          },
          keepalive: true,
          method: "POST"
        }).then((response) => {
          if (response.status < 300) {
            resolve(true);
          } else {
            reject(`Error: ${response.status} - ${response.statusText}`);
          }
        }).catch((error) => {
          if (options.debug) {
            console.error("Error(s) sending events:");
            console.dir(error, { depth: null });
          }
          reject(error);
        });
        break;
    }
  });
}

// src/batching/send-events/send-events.ts
async function sendEvents(useBeacon = false) {
  if (typeof window !== "undefined" && window.yvaDatastore) {
    const endpoint = window.yvaDatastore.config.endpoint;
    lockEvents().then((events) => {
      const eventBatches = events.events?.reduce(
        (batches, currentEvent) => {
          if (window.yvaDatastore) {
            const context = window.yvaDatastore.contexts[currentEvent.contextId];
            if (context && context.status === "ready" && currentEvent) {
              if (!batches[currentEvent.contextId]) {
                batches[currentEvent.contextId] = { context: context.data, events: [] };
              }
              batches[currentEvent.contextId].events.push(currentEvent.data);
            }
          }
          return batches;
        },
        {}
      );
      if (eventBatches && Object.keys(eventBatches).length) {
        Promise.allSettled(
          Object.values(eventBatches).map((batchPayload) => {
            if (window.yvaDatastore) {
              return sendEventBatch(
                { payload: batchPayload, url: endpoint },
                { debug: window.yvaDatastore.config.debug ?? false, requestMode: useBeacon ? "beacon" : "fetch" }
              );
            }
          })
        ).then((batchResults) => {
          batchResults.forEach((batchResult, index) => {
            const batch = Object.values(eventBatches)[index];
            if (batchResult.status === "fulfilled") {
              batch.events.forEach((event) => {
                if (window.yvaDatastore) {
                  const lockedEvent = window.yvaDatastore.events.find(
                    (datastoreEvent) => datastoreEvent.data.eventId === event.eventId
                  );
                  if (lockedEvent) {
                    lockedEvent.status = "sent";
                    lockedEvent.lockId = null;
                  }
                }
              });
            } else {
              if (window.yvaDatastore && window.yvaDatastore.config.debug) {
                console.error(
                  "Error(s) sending events to API for contextId",
                  Object.keys(eventBatches)[index],
                  "\nReason:",
                  batchResult.reason
                );
                console.dir(Object.values(eventBatches)[index], { depth: null });
              }
              batch.events.forEach((event) => {
                if (window.yvaDatastore) {
                  const lockedEvent = window.yvaDatastore.events.find(
                    (datastoreEvent) => datastoreEvent.data.eventId === event.eventId
                  );
                  if (lockedEvent) {
                    lockedEvent.lockId = null;
                  }
                }
              });
            }
          });
          cleanupEvents();
        });
      }
    });
  }
}

// src/utils/retry/wait-for-context-to-be-ready/wait-for-context-to-be-ready.ts
async function waitForContextToBeReady(timeoutMs = 5e3) {
  const startTime = performance.now();
  while (performance.now() - startTime < timeoutMs) {
    if (typeof window !== "undefined" && window.yvaDatastore?.currentContextId && window.yvaDatastore.contexts[window.yvaDatastore.currentContextId].status === "ready") {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, 250));
  }
  if (window?.yvaDatastore?.config.debug) {
    console.error("Timed out waiting for current context to be ready.");
  }
  return false;
}

// src/contexts/merge-analytics-contexts/merge-analytics-contexts.ts
function mergeAnalyticsContexts(prevContext, values) {
  let newContext = structuredClone(prevContext);
  const { browser, device, geo, ...topLevelNonObjects } = values;
  newContext = {
    ...newContext,
    ...topLevelNonObjects
  };
  if (browser) {
    newContext.browser = {
      ...newContext.browser,
      ...browser
    };
  }
  if (device) {
    newContext.device = {
      ...newContext.device,
      // Casting is required because of how TS parses `device.type` with RecursivePartial. The types are identical.
      ...device
    };
  }
  if (geo) {
    newContext.geo = {
      ...newContext.geo,
      ...geo
    };
  }
  return newContext;
}

// src/contexts/update-current-context/update-current-context.ts
async function updateCurrentContext(values) {
  if (window.yvaDatastore && window.yvaDatastore.currentContextId) {
    const contextIsReady = await waitForContextToBeReady();
    let newContextId = self.crypto.randomUUID();
    let currentContext = window.yvaDatastore.contexts[window.yvaDatastore.currentContextId];
    if (contextIsReady && currentContext && currentContext.status === "ready") {
      window.yvaDatastore.contexts[newContextId] = {
        data: { device: {} },
        status: "initialized"
      };
      window.yvaDatastore.currentContextId = newContextId;
      const newContextData = mergeAnalyticsContexts(
        currentContext.data,
        /**
         * Intentionally overloading the source of values because some pieces of the context may require an async call to get the value. This is similar to `initializeContext` except in this case we're merging objects.
         */
        typeof values === "function" ? await values() : values
      );
      window.yvaDatastore.contexts[newContextId] = { data: newContextData, status: "ready" };
    }
  }
  sendEvents();
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  updateCurrentContext
});
